import { Component } from '@angular/core';

/**
 * Help page
 *
 * @export
 * @class HelpComponent
 */
@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    standalone: false
})
export class HelpComponent { }
